<template>
  <v-overlay
    :value="show"
  >
    <v-card
      elevation=2
      class="card pa-2"
      min-width="250"
    >

      <v-normal-loading v-if="isNormal"/>
      <v-print-loading v-if="isPrint"/>

      <v-card-text class="card__text pa-2">
        {{message}}
      </v-card-text>
    </v-card>

  </v-overlay>
</template>

<script>
import VNormalLoading from '@/components/atoms/NormalLoading'
import VPrintLoading from '@/components/atoms/PrintLoading'

export default {
  components: {
    VNormalLoading,
    VPrintLoading,
  },
  data: () => ({
    show: false,
    message: "Loading...",
    // normal | print
    type: 'normal'
  }),

  computed: {
    // flags
    isNormal() {
      return this.type === 'normal'
    },
    isPrint() {
      return this.type === 'print'
    },
  },

  methods: {
    open({ message=null, type=null }) {
      this.show = true;
      if (message) this.message = message
      if (type) this.type = type
    },

    close() {
      this.show = false;
    }
  }
}
</script>

<style lang="stylus" scoped>
.card
  z-index 1000
  background-color white !important
  border-left solid 3px #313e80
  padding 10px

  &__text
    text-align center
    font-size 16px
    color #313e7f !important
    font-weight 600
</style>
